<template>
	<page>
		<module :title="id ? '编辑满赠满减活动' : '新建满赠满减活动'">
			<c-form ref="form">
				<c-form-item type="input" label="活动名称" name="name" required></c-form-item>
				<c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
				<c-form-item v-model="type" type="radio" label="活动类型" name="type" :options="typeOption" required ></c-form-item>
				<c-form-item v-model="kinds" type="radio" label="是否叠加" name="kinds" :options="kindsOption" required ></c-form-item>
				<c-form-item >
					<div class="limit flex">
						<div class="flex-center-cross item">
							<label>{{kinds == 1 ? '订单每满' : '订单满'}}</label>
							<c-input v-model="reward_order_product_money" name="reward_order_product_money" type="number" decimal="2" width="135" height="38" word="元"></c-input>
						</div>
						<div class="flex-center-cross item" v-show="type == 1">
							<label>减</label>
							<c-input v-model="reduce_money" name="reduce_money" type="number" decimal="2" width="135" height="38" word="元"></c-input>
						</div>
						<div class="flex-center-cross item" v-show="type == 2">
							<label>送赠品，请在下方选择赠品</label>
						</div>
					</div>
				</c-form-item>
				<c-form-item v-if="type == 2" label="" required>
					<m-operate>
						<c-button color="gray" hollow @click="$refs.productSelector.open()">添加赠品</c-button>
					</m-operate>
					
					<c-table ref="productList" v-model="productList" height="500" :paging="false" border>
						<c-table-column
							type="selector"
						></c-table-column>
						
						<c-table-column
							label="商品信息"
							name="product_name"
							width="260"
						>
							<template v-slot="{data}">
								<div class="flex-center">
									<c-image :src="data.product_img_url" size="46" preview></c-image>
									<p class="flex-grow ellipsis-2" style="margin-left: 12px;">{{data.product_name}}</p>
								</div>
							</template>
						</c-table-column>
						
						<c-table-column
							label="商品货号"
							name="product_itemnumber"
						></c-table-column>
						
						<c-table-column
							label="商品规格"
							name="product_sku_spec"
						></c-table-column>
						
						<c-table-column
							label="价格"
							name="product_price"
							width="80"
						>
							<template v-slot="{data}">￥{{data.product_price}}</template>
						</c-table-column>
						
						<c-table-column
							label="库存"
							name="stock_count"
							width="80"
						></c-table-column>
						
						<c-table-column
							label="赠送数量"
							width="80"
						>
							<template v-slot="{data}">
								<c-input v-model="data.count" width="50" type="number" :limit="[1,999]" style="margin: 0 5px;"></c-input>
							</template>
						</c-table-column>
						
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="80"
						>
							<template v-slot="row">
								<c-table-button @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit(1)">确定提交</c-button>
			</template>
		</module>
		<!--商品库控件-->
		<product-selector ref="productSelector" sku multiple gift @resolve="productSelectHandle"></product-selector>
	</page>
</template>

<script>
	import productSelector from '@/components/service/product_selector.vue'
	
	export default {
		name: 'global_reward_edit',
		
		components: {
			productSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				typeOption: [{
						name: '满减',
						value: 1
					}, {
						name: '满赠',
						value: 2
					}
				],
				type: 1,
				kinds: 1,
				kindsOption: [{
					name: '叠加',
					value: 1
				}, {
					name: '不叠加',
					value: 2
				}],
				reward_order_product_money: 0,
				reduce_money: 0,
				productList: []
			}
		},
		watch: {
			id() {
				this.getActivityDetail();
			},
			
			commodityRange(val) {
				if (val == 2) {
					this.$refs.productList.resize();
				}
			}
		},
		
		mounted() {
			this.id && this.getActivityDetail();
		},
		
		methods: {
			//获取活动详情
			getActivityDetail() {
				this.request({
					url: '/globalReward/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						this.reward_order_product_money = data.reward_order_product_money;
						this.reduce_money = data.reduce_money||0;
						this.productList = data.product_list;
					}
				});
			},
			//商品选择回调
			productSelectHandle(list) {
				if(list){
					//默认赠品1件
					list.forEach(gift => {
						gift.count = 1;
					});

				}
				list = list.filter(item => {
					return !this.productList.find(row => {
						return row.product_sku == item.product_sku;
					});
				});
				this.productList = this.productList.concat(list);
			},
			//提交保存
			submit(state) {
				this.$refs.form.submit({
					url: this.id ? '/globalReward/edit' : '/globalReward/add',
					rule: {
						name: '请填写活动名称',
						begin_date: '请选择活动时间',
						type: '请选择活动类型',
						reduce_money_fun: [{
							type: 'function',
							fun: () => {
								if(this.type == 1){
									return this.reward_order_product_money && this.reduce_money;
								}else{
									return this.reward_order_product_money;
								}
							},
							word: this.type == 2 ? '请填写优惠门槛' : '请填写优惠门槛及满减金额'
						}],
						product_list: [{
							type: 'function',
							fun: () => {
								//满赠
								if(this.type == 2){
									return this.productList.length;
								}else{
									return true;
								}
							},
							word: '请选择赠品'
						}],
						product_config: [{
							type: 'function',
							fun: () => {
								return !this.productList.find(item => {
									return !item.count;
								});
							},
							word: '请设置赠品数量'
						}]
					},
					
					dataFormatter: data => {
						this.id && (data.id = this.id);
						data.reward_order_product_money = this.reward_order_product_money;
						data.reduce_money = this.reduce_money;
						data.product_list = Array.from(this.productList, item => {
							return {
								product_id: item.product_id,
								product_sku: item.product_sku,
								count: item.count,
							}
						});
						
						return data;
					},
					
					success: () => {
						this.$message({
							icon: 'success',
							text: '活动数据保存成功'
						});
						this.$bus.$emit('globalRewardList.update');
						this.redirectTo('/global_reward');
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.limit {
		.item {
			margin-right: 16px;
			
			label {
				margin-right: 8px;
			}
		}
	}
</style>